(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8614],{

/***/ 35593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo"},"directives":[]}]}}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"#import \"@xem/user-common/graphql/User.graphql\"\nfragment CurrentUserInfo on Query{\n  currentUser { ...UserInfo }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(96577).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.CurrentUserInfo = oneQuery(doc, "CurrentUserInfo");
        


/***/ }),

/***/ 16634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"route"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vars"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Any"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteInfo"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentUserInfo"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"res"},"name":{"kind":"Name","value":"route"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"vars"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vars"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"runtimejs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hlinks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"metatags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":357}};
    doc.loc.source = {"body":"#import \"./SiteInfo.graphql\"\n#import \"./CurrentUser.graphql\"\n\nquery route($path: String!, $language: String, $vars: Any) {\n  ... SiteInfo\n  ... CurrentUserInfo\n  res: route(path: $path, language: $language, vars: $vars) {\n    type_name\n    runtimejs\n    id\n    title\n    hlinks {\n      key\n      value\n    }\n    metatags {\n      key\n      value\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(12347).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(35593).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.route = oneQuery(doc, "route");
        


/***/ }),

/***/ 12347:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"localkey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upload"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sologan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firebase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"domain"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol_after"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thousands_marker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"decimal_marker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precision"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mark"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":540}};
    doc.loc.source = {"body":"fragment SiteInfo on Query{\n  \tsession\n    localkey\n    site {\n      name\n      mail\n      upload\n      sologan\n      client_id\n      firebase\n      storeId\n      country\n      domain {\n        id\n        full\n      }\n      currency\n      # currency tốc độ load ip 2 currency ảnh hưởng tới tốc độ site tạm thời ko load.\n      # tạo index cho database ip2location\n      currencies {\n          code\n          symbol\n          symbol_after\n          thousands_marker\n          decimal_marker\n          precision\n          mark\n      }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.SiteInfo = oneQuery(doc, "SiteInfo");
        


/***/ }),

/***/ 78614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Page; },
  "k": function() { return /* binding */ getInitialProps; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/base/utils/merge/mergeObject.js
var mergeObject = __webpack_require__(93155);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../packages/common/redirect/redirect.js

/**
 * redirectTo
 * @param to
 * @param res
 */ const redirectTo = function(to) {
    let { res  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    to = encodeURI(to);
    if (res) {
        res.writeHead(307, {
            "Location": to
        });
        res.end();
    } else {
        router_default().replace(to).then(()=>{});
    }
};
/* harmony default export */ var redirect_redirect = (redirectTo);

;// CONCATENATED MODULE: ../packages/common/redirect/index.js



// EXTERNAL MODULE: ../modules/router/common/graphql/Route.graphql
var Route_graphql = __webpack_require__(16634);
var Route_graphql_default = /*#__PURE__*/__webpack_require__.n(Route_graphql);
;// CONCATENATED MODULE: ../modules/router/common/graphql/index.ts


// EXTERNAL MODULE: ../../node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(94803);
;// CONCATENATED MODULE: ../modules/router/common/classes/RouteOperations.ts

// @ts-ignore



/**
 * @var client graphql
 * @param fetchPolicy
 * @param variables
 */ const getRoute = function() {
    let { fetchPolicy , variables  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (client)=>{
        variables = variables || {
            path: "/"
        };
        return client.query({
            query: (Route_graphql_default()),
            variables,
            fetchPolicy: fetchPolicy || "cache-first"
        });
    };
};
/**
 *
 * @param Component
 */ const withRouteQuery = (input)=>(Component)=>compose(withProps((props)=>mapInput(input, props)), // withProps(({ asPath, routeSkip }: any) => error({ asPath, routeSkip })),
        graphql(ROUTER, {
            skip: (param)=>{
                let { routeSkip , asPath  } = param;
                return !asPath || routeSkip;
            },
            options: (param)=>{
                let { asPath: path , load  } = param;
                path = path || "/";
                path = "".concat(path).replace(".html", "");
                return {
                    variables: {
                        path,
                        load: !!load
                    }
                };
            },
            props: async (param)=>{
                let { data: { loading , route: content  } , ownProps: { route  }  } = param;
                if (!loading) {
                    route.save(content || {});
                }
                return {
                    loading,
                    route
                };
            }
        }))(Component);

;// CONCATENATED MODULE: ../modules/router/common/index.tsx




// EXTERNAL MODULE: ../packages/client/index.tsx + 407 modules
var client = __webpack_require__(52186);
// EXTERNAL MODULE: ../modules/user/common/classes/User.tsx
var User = __webpack_require__(45689);
// EXTERNAL MODULE: ../../packages/modules/core/common/clientStorage.ts
var clientStorage = __webpack_require__(71783);
;// CONCATENATED MODULE: ../modules/router/common-react/page.tsx







/**
 * Default Page
 * @param props
 * @constructor
 */ function Page(props) {
    // @ts-ignore
    return /*#__PURE__*/ react.createElement(client/* default.router */.Z.router, props);
}
/**
 * getInitialProps
 * @param load
 * @param route_type
 * @param apolloClient
 * @param asPath
 * @param path
 * @param headers
 * @param query
 * @param ctx
 */ const getInitialProps = async function() {
    let { load , route_type , apolloClient , asPath , path , headers , query , ...ctx } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let start_time = new Date().getTime(), runtimejs = false, type_name, graphqlRoute = {}, session = {}, localKey;
    let currentUser, redirect, site, firebaseSettings;
    let history = [], pathLast, cookiePaths;
    error("getInitialProps", start_time);
    path = path || "/";
    let pathto = path.replace("/dashboard", "/");
    ctx = (0,mergeObject/* default */.Z)({
        headers,
        apolloClient,
        path,
        asPath,
        query
    }, ctx);
    try {
        if (!__SERVER__) {
            cookiePaths = getCookie("history", ctx);
            if (cookiePaths) {
                history = JSON.parse(cookiePaths);
            }
            history = history || [];
        }
        try {
            pathLast = [
                ...history
            ].at(-1);
        } catch (e) {}
        if (pathLast !== pathto) {
            history.push(pathto);
        }
        history = [
            ...history.slice(-5)
        ];
        setCookie("history", JSON.stringify(history), __SERVER__ ? {
            req: ctx === null || ctx === void 0 ? void 0 : ctx.req,
            res: ctx === null || ctx === void 0 ? void 0 : ctx.res
        } : null);
        Object.assign(ctx, {
            history
        });
    } catch (e1) {
        debug("##### error ####", e1);
    }
    try {
        var ref, ref1;
        let vars = parseInt(query === null || query === void 0 ? void 0 : query.qrtag) === 1 ? "qrcode" : "view";
        // debug('######withRouteContainer',{ path, vars, apolloClient })
        /** Load du lieu website cung voi cookie */ const result = await getRoute({
            variables: {
                path,
                vars
            }
        })(apolloClient);
        // debug('######withRouteContainer',{ result, route_type })
        let data = (result === null || result === void 0 ? void 0 : result.data) || {};
        await apolloClient.writeQuery({
            query: (Route_graphql_default()),
            data,
            variables: {
                path
            }
        });
        /** Set variable */ currentUser = (data === null || data === void 0 ? void 0 : data.currentUser) || {};
        site = (data === null || data === void 0 ? void 0 : data.site) || {};
        session = (data === null || data === void 0 ? void 0 : data.session) || {};
        localKey = (data === null || data === void 0 ? void 0 : data.localkey) || null;
        firebaseSettings = (data === null || data === void 0 ? void 0 : (ref = data.site) === null || ref === void 0 ? void 0 : ref.firebase) || {};
        /*** The variable has been set */ if (data === null || data === void 0 ? void 0 : (ref1 = data.res) === null || ref1 === void 0 ? void 0 : ref1.runtimejs) runtimejs = true;
        /** * Checked load database */ if (load) {
            graphqlRoute = (data === null || data === void 0 ? void 0 : data.res) || {};
            type_name = graphqlRoute === null || graphqlRoute === void 0 ? void 0 : graphqlRoute.type_name;
            if (type_name === "TypeIsRedirect" && (graphqlRoute === null || graphqlRoute === void 0 ? void 0 : graphqlRoute.title)) {
                redirect = graphqlRoute === null || graphqlRoute === void 0 ? void 0 : graphqlRoute.title;
            }
        }
    } catch (e2) {
        debug(path, e2);
    }
    // debug('######graphqlRoute', load, graphqlRoute)
    route_type = route_type || type_name;
    /*** redirect from getInitialProps */ if (type_name === "TypeIsRedirect" && redirect && redirect !== path) {
        redirect_redirect(redirect, ctx);
    }
    /** get route_type **/ client/* default.props */.Z.props = {
        route_type,
        path
    };
    client/* default.typeByRoute */.Z.typeByRoute && (route_type = client/* default.typeByRoute */.Z.typeByRoute);
    // debug('######withRoute', 'getInitialProps', { route_type, type_name, query })
    try {
        const preUrl = await (0,clientStorage/* getItem */.rV)("location");
        ctx = (0,mergeObject/* default */.Z)({
            preUrl
        }, ctx);
    } catch (e3) {
        debug(e3);
    }
    ctx = (0,mergeObject/* default */.Z)({
        localKey,
        session,
        site,
        firebaseSettings,
        currentUser,
        headers,
        graphqlRoute,
        route_type
    }, ctx);
    try {
        let routeProps = client/* default.getRouteProps */.Z.getRouteProps;
        if (routeProps) {
            const { perms , redirectOnLoggedIn , redirectOnAnonymous , redirect: to = "/"  } = routeProps || {};
            if (routeProps === null || routeProps === void 0 ? void 0 : routeProps.runtimejs) runtimejs = true;
            ctx = (0,mergeObject/* default */.Z)({
                runtimejs,
                start_time
            }, ctx);
            /**
       * check type of page
       */ try {
                let user = User/* default.instanse */.Z.instanse(currentUser);
                if (to !== path && (typeof redirectOnLoggedIn == "boolean" && redirectOnLoggedIn && !!user.id || typeof redirectOnAnonymous == "boolean" && redirectOnAnonymous && !user.id || perms && !user.hasPerms(perms))) {
                    redirect_redirect(to, ctx);
                }
            } catch (e4) {
                debug(e4);
            }
            /**
       *
       */ routeProps.getInitialProps && (ctx = (0,mergeObject/* default */.Z)(await routeProps.getInitialProps(ctx), ctx));
        }
    } catch (e5) {
        debug(e5);
    }
    return ctx;
};


/***/ })

}]);